import { useQuery } from "react-query";
import authAPI from "../authAPI";

export const useFeideGroups = (organizationId, showHidden = false, options = {}) => {
  return useQuery(
    ["feideGroups", organizationId, showHidden],
    async () => {
      const result = await authAPI.getFeideGroupsForOrganization(organizationId, showHidden);
      return result;
    },
    {
      enabled: !!organizationId,
      refetchOnMount: true,
      staleTime: 0,
      // Refetch every 3 seconds if empty (children might be importing)
      refetchInterval: (data) => {
        if (data?.data && Array.isArray(data.data) && data.data.length === 0) {
          return 3000;
        }
        return false;
      },
      ...options,
    }
  );
};
